module.exports = __webpack_public_path__ + "img/item_001.3c94fe51.png";